import './problem.css'
import { useI18n } from '../lib/i18n'
import { Reveal } from '../components/Reveal'
import { SectionHeader } from '../components/SectionHeader'
import { HudCard } from '../components/HudCard'

// Section 01 — VẤN ĐỀ. Three HudCards framing EUDR readiness as a records problem.
export default function Problem() {
  const { lang } = useI18n()
  const C = (
    {
      vi: {
        kicker: 'VẤN ĐỀ',
        title: (
          <>
            Thời điểm đã rõ, dữ liệu thì <em>chưa có</em>.
          </>
        ),
        sub: 'EUDR áp dụng từ 30/12/2026 — còn khoảng bốn tháng để bản đồ hóa vùng trồng trước vụ thu đầu tiên chịu quy định. Đây là bài toán hồ sơ, không phải bài toán canh tác.',
        cards: [
          {
            n: '01',
            head: 'HỒ SƠ',
            title: 'Chưa có hồ sơ tuân thủ',
            body: 'Phần lớn vùng trồng thiếu định vị địa lý và giấy tờ pháp lý đất ở dạng có thể nộp. Lot Passport và GeoJSON cho TRACES NT cần dữ liệu chuẩn — thứ mà hộ nông dân hiện chưa lưu giữ.',
          },
          {
            n: '02',
            head: 'TRUY XUẤT',
            title: 'Truy xuất đứt khi gom hàng',
            body: 'Cà phê trộn qua nhiều thương lái trước khi đến nhà xuất khẩu. Khi lô hàng đã pha trộn, nhà mua EU không thể lần ngược về từng thửa nguồn để chứng minh không phá rừng sau mốc 31/12/2020.',
          },
          {
            n: '03',
            head: 'NĂNG LỰC',
            title: 'HTX không thể tự số hóa',
            body: 'Bản đồ hóa cần khảo sát GIS và xử lý ranh giới xen canh phức tạp. Hợp tác xã thiếu cả nhân lực kỹ thuật lẫn ngân sách để tự làm trước thời hạn.',
          },
        ],
      },
      en: {
        kicker: 'THE PROBLEM',
        title: (
          <>
            The deadline is set, the data <em>is not</em>.
          </>
        ),
        sub: 'EUDR applies from 30 Dec 2026 — roughly four months to map plots before the first harvest under the rule. This is a records problem, not a farming problem.',
        cards: [
          {
            n: '01',
            head: 'RECORDS',
            title: 'No compliance file exists',
            body: 'Most plots lack geolocation and submittable land-title records. A Lot Passport and GeoJSON for TRACES NT need clean data — exactly what smallholders do not keep today.',
          },
          {
            n: '02',
            head: 'TRACEABILITY',
            title: 'Traceability breaks at aggregation',
            body: 'Coffee is mixed across many traders before reaching the exporter. Once a lot is blended, EU buyers cannot trace it back to each source plot to prove no deforestation after the 31 Dec 2020 cutoff.',
          },
          {
            n: '03',
            head: 'CAPACITY',
            title: 'Co-ops cannot digitize alone',
            body: 'Mapping requires GIS surveying and resolving tangled intercropped boundaries. Co-operatives lack both the technical staff and the budget to do it themselves before the deadline.',
          },
        ],
      },
    } as const
  )[lang]

  return (
    <section id="problem" className="section problem">
      <div className="container">
        <SectionHeader index="01" kicker={C.kicker} title={C.title} sub={C.sub} />

        <div className="problem-grid">
          {C.cards.map((card, i) => (
            <Reveal key={card.n} delay={0.06 + i * 0.08} y={24}>
              <HudCard header={<>{card.head}</>} brackets>
                <h3 className="problem-card-title">{card.title}</h3>
                <p className="problem-card-body">{card.body}</p>
              </HudCard>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
